.outer {
  composes: -center from "../util.module.css";
  composes: -expand from "../util.module.css";

  position: relative;
}

.overlay {
  composes: -center from "../util.module.css";
  composes: -expand from "../util.module.css";

  position: absolute;
  pointer-events: none;
  color: rgba(255, 0, 0, 0.4);
  transform: rotate(-30deg);
  font-size: 18em;
}
